import { Directive, HostBinding, HostListener, Input, EventEmitter, ChangeDetectorRef } from "@angular/core";
import * as ɵngcc0 from '@angular/core';
var CalendarItem = /** @class */ (function () {
    function CalendarItem(date) {
        this.date = date;
    }
    return CalendarItem;
}());
export { CalendarItem };
var SuiCalendarItem = /** @class */ (function () {
    function SuiCalendarItem(changeDetector) {
        this.changeDetector = changeDetector;
        this.hasFocus = false;
        this.onFocussed = new EventEmitter();
    }
    Object.defineProperty(SuiCalendarItem.prototype, "isSelectable", {
        get: function () {
            return this.item.isSelectable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiCalendarItem.prototype, "isActive", {
        get: function () {
            return this.item.isActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiCalendarItem.prototype, "isToday", {
        get: function () {
            return this.item.isToday;
        },
        enumerable: true,
        configurable: true
    });
    SuiCalendarItem.prototype.onMouseMove = function () {
        if (!this.hasFocus) {
            this.hasFocus = true;
            this.onFocussed.emit(this.hasFocus);
        }
    };
    SuiCalendarItem.prototype.onMouseLeave = function () {
        this.hasFocus = false;
        this.onFocussed.emit(this.hasFocus);
    };
    /** @nocollapse */
    SuiCalendarItem.ctorParameters = function () { return [
        { type: ChangeDetectorRef, },
    ]; };
    SuiCalendarItem.propDecorators = {
        "item": [{ type: Input, args: ["calendarItem",] },],
        "isSelectable": [{ type: HostBinding, args: ["class.disabled",] },],
        "isActive": [{ type: HostBinding, args: ["class.active",] },],
        "isToday": [{ type: HostBinding, args: ["class.today",] },],
        "hasFocus": [{ type: HostBinding, args: ["class.focus",] },],
        "onMouseMove": [{ type: HostListener, args: ["mousemove",] },],
        "onMouseLeave": [{ type: HostListener, args: ["mouseleave",] },],
    };
SuiCalendarItem.ɵfac = function SuiCalendarItem_Factory(t) { return new (t || SuiCalendarItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SuiCalendarItem.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SuiCalendarItem, selectors: [["", "calendarItem", ""]], hostVars: 8, hostBindings: function SuiCalendarItem_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousemove", function SuiCalendarItem_mousemove_HostBindingHandler() { return ctx.onMouseMove(); })("mouseleave", function SuiCalendarItem_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("focus", ctx.hasFocus)("disabled", ctx.isSelectable)("active", ctx.isActive)("today", ctx.isToday);
    } }, inputs: { item: ["calendarItem", "item"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiCalendarItem, [{
        type: Directive,
        args: [{
                selector: "[calendarItem]"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { hasFocus: [{
            type: HostBinding,
            args: ["class.focus"]
        }], isSelectable: [{
            type: HostBinding,
            args: ["class.disabled"]
        }], isActive: [{
            type: HostBinding,
            args: ["class.active"]
        }], isToday: [{
            type: HostBinding,
            args: ["class.today"]
        }], onMouseMove: [{
            type: HostListener,
            args: ["mousemove"]
        }], onMouseLeave: [{
            type: HostListener,
            args: ["mouseleave"]
        }], item: [{
            type: Input,
            args: ["calendarItem"]
        }] }); })();
    return SuiCalendarItem;
}());
export { SuiCalendarItem };

